import { REMOTE_TEXT_SEARCH_MIN_LENGTH, hasRemoteTextSearchMinLength } from '../remote-text-search.helper'

const isString = (value: unknown): value is string => typeof value === 'string'

export const CONFIG_TEXT_SEARCH_MIN_LENGTH = REMOTE_TEXT_SEARCH_MIN_LENGTH

export const hasConfigTextSearchMinLength = (value: string): boolean =>
	hasRemoteTextSearchMinLength(value, CONFIG_TEXT_SEARCH_MIN_LENGTH)

export const applyConfigTextSearchMinLength = <T extends object>(
	filters: Partial<T>,
	textKeys: readonly (keyof T)[]
): Partial<T> => {
	const textKeySet = new Set<keyof T>(textKeys)

	return (Object.entries(filters) as [keyof T, T[keyof T]][]).reduce((acc, [key, value]) => {
		if (value === null || value === undefined) return acc
		if (isString(value)) {
			const trimmedValue = value.trim()
			if (!trimmedValue) return acc
			if (textKeySet.has(key) && !hasConfigTextSearchMinLength(trimmedValue)) return acc
			acc[key] = trimmedValue as T[keyof T]
			return acc
		}

		acc[key] = value
		return acc
	}, {} as Partial<T>)
}
